module.exports = __webpack_public_path__ + "static/media/car_charger.314a842f.png";